/* jshint esnext: true */
import AbstractModule from './AbstractModule';

import {scrollTo} from '../global/scrollTo';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Basic elements needed for visual interactions
        this.$form          = null;
        this.$errorMessages = null;
        this.$preSubmit     = null;
        this.$postSubmit    = null;
        this.hasErrors      = null;
        this.firstInvalid   = null;

        this.initForm();

        setTimeout(() => {
            this.$captcha.each(function () {
                grecaptcha.render(this.id, {
                    sitekey: '6LfBzwYUAAAAALQSwfai31MF9RuE_HXQCvtV6q4a'
                });
            });
        }, 1000)
    }

    initForm() {
        this.setElements();

        this.$captcha = this.$el.find('.js-captcha');

        this.replaceValidationUI();

        this.$el.on('change.Form', '.js-input', (event) => this.onInput(event));

        this.$el.on('submit.Form', '.js-form', (event) => {
            event.preventDefault();
            this.manageSubmit();
        });
    }

    /**
     * Update label state on field update.
     *
     * @param  {Object} event Change event
     * @return {void}
     */
    onInput(event) {
        const $el = $(event.currentTarget);
        const target = $el.attr('data-toggle-target');
        if (typeof target !== 'undefined' && target !== '') {
            const $target = $(target, this.$form);
            const isShow = typeof $el.attr('data-show-target') !== 'undefined';
            const isHide = typeof $el.attr('data-hide-target') !== 'undefined';

            if ($target.length > 0) {
                if (isShow) {
                    $target.removeClass('u-hidden');
                } else if (isHide) {
                    $target.addClass('u-hidden');
                }
            }
        }
    }

    /**
     * Manage errors sent by back end on front end
     * @param  {array}  errors  List of error objects
     * @return void
     */
    manageErrors(errors) {
        // Reset captcha
        if (typeof(window.grecaptcha) !== 'undefined') {
            window.grecaptcha.reset();
        }

        var i = 0, len = errors.length;
        for (; i < len; i++) {
            $('#' + errors[i].property).addClass('has-error');
            $('#js-error-' + errors[i].property).text(errors[i].message).attr('aria-hidden', 'false');
        }
    }

    replaceValidationUI() {
        let form = this.$form;
        this.$form.find(':input').on('invalid.Form', (event) => {
            event.preventDefault();
            let input = $(event.currentTarget);
            input.addClass('has-error');

            if (!this.firstInvalid) {
                this.firstInvalid = input;
                this.scrollToFirstInvalid();
            }

            let message   = document.documentElement.lang === 'fr' ? 'champs manquant' : 'missing field';
            let errorSpan = input.closest('.o-form_item').find('.js-error-message');
            errorSpan.text(message).attr('aria-hidden', 'false').addClass('has-error');

            input.on('change.Form', (event) => {
                if (input[0].checkValidity()) {
                    input.removeClass('has-error');
                    errorSpan.removeClass('has-error');
                } else {
                    input.addClass('has-error');
                    errorSpan.addClass('has-error');
                }
            });
        });
    }

    scrollToFirstInvalid() {
        this.firstInvalid.focus();

        setTimeout(() => {
            this.firstInvalid = null;
        }, 1000);
    }

    /**
     * Submits the form data to an URL with $.ajax
     * @return void
     */
    manageSubmit() {
        if (!this.isTransmitting) {
            this.isTransmitting = true;
            this.$errorMessages.text('').attr('aria-hidden', 'true');
            this.toggleLoading();

            let mode = this.$form.data('form-mode');
            switch (mode) {
                case 'redirect':
                    this.$el.off('.Form');
                    this.$form.submit();
                    return;
            }

            setTimeout(() => {
                var jqxhr = $.ajax({
                    method: 'POST',
                    url   : this.$form.attr('action'),
                    data  : this.$form.serializeArray()
                })
                    .done((response) => {
                        if (response.success === true) {
                            this.$preSubmit.fadeOut(() => {
                                this.$postSubmit.fadeIn();
                            });
                        } else {
                            this.manageErrors(response.errors);
                        }
                    })
                    .always(() => {
                        setTimeout(() => {
                            scrollTo(this.$el, {
                                offset: 60
                            });
                            this.toggleLoading();
                            this.isTransmitting = false;
                        }, 600);
                    });
            }, 600);
        }
    }

    /**
     * Method used to set needed elements when document is ready.
     * Basically for any form with Ractive
     */
    setElements() {
        this.$form          = this.$el.find('.js-form');
        this.$errorMessages = this.$el.find('.js-error-message');
        this.$preSubmit     = this.$el.find('.js-pre-submit');
        this.$postSubmit    = this.$el.find('.js-post-submit');
    }

    /**
     * Simple method for toggling animation states
     * @return void
     */
    toggleLoading() {
        this.$el.toggleClass('is-form-state-loading');
    }

    destroy() {
        this.$el.off('.Form');
    }
}
